import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type ModelSubscriptionService from '@/services/transport/modelSubscriptionService'
import type { WizardApplyBody } from '@/services/domain/wizard/types'
import { wizardChangeStepEvent } from '@/services/domain/wizard/wizardService'
import type { Resolvable } from '@/services/resolvers/types'
import type SignUpTrackingService from '@/services/tracking/signUp/signUpTrackingService'

@injectable()
export default class WizardAnalyticsResolverService implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.ModelSubscriptionService) protected readonly subscription: ModelSubscriptionService,
    @inject(SERVICE_TYPES.SignUpTrackingService) protected readonly signUpTrackingService: SignUpTrackingService,
  ) {}

  private subscriptionKey: string | null = null

  private changeStepHandler = (e: WizardApplyBody) => {
    if (e.type !== 'from_configure_analytics_to_finish' && e.type !== 'from_configure_analytics_to_getting_started') {
      return
    }
    this.signUpTrackingService.trackSignUp(String(e.type))
  }

  public async resolve() {
    this.subscriptionKey = this.subscription.subscribe(wizardChangeStepEvent, this.changeStepHandler)
  }

  public async unresolve() {
    if (!this.subscriptionKey) {
      return
    }
    this.subscription.unsubscribe([this.subscriptionKey])
  }
}
